import { render, staticRenderFns } from "./MyDocumentsTile.vue?vue&type=template&id=5a570981&scoped=true"
import script from "./MyDocumentsTile.vue?vue&type=script&lang=ts"
export * from "./MyDocumentsTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a570981",
  null
  
)

export default component.exports